import { Controller } from "@hotwired/stimulus";

// Throttles form submission when quantity input changes
export default class extends Controller {
  static values = { delay: { default: 100, type: Number } };

  connect() {
    this.timeout = null;
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  throttleSubmit(event) {
    const input = event.target;

    // Validate and correct the input value
    this.validateQuantity(input);

    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    // Set a new timeout to submit the form after the delay
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.delayValue);
  }

  validateQuantity(input) {
    const value = input.value.trim();

    // If empty or invalid, set to 1
    if (value === "" || isNaN(value) || parseInt(value) < 1) {
      input.value = "1";
      return;
    }

    // Ensure it's a positive integer
    const intValue = parseInt(value);
    if (intValue !== parseFloat(value) || intValue < 1) {
      input.value = Math.max(1, Math.floor(Math.abs(intValue)));
    }
  }
}
